import React, { useCallback, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';

import GoToStoreButton from '../go-to-store-button';
import PriceColumn from '../price-column';
import StockStatusColumn from '../stock-status-column';

import { AlternativePrice, Store } from '../../../../types';
import { TableLinkProps } from '../../types';

import * as Table from '../../styles/table';
import * as S from './styles';

type OwnProps = {
  campaignStyling?: string;
  externalUri?: string;
  onClickOut: (e: React.MouseEvent, id?: string | null) => void;
  isInternationalPrice: boolean;
  price: AlternativePrice;
  priceStore: Store;
  tableLinkProps: TableLinkProps;
};

const AlternativePriceRow = ({
  campaignStyling,
  externalUri,
  onClickOut,
  isInternationalPrice,
  price,
  priceStore,
  tableLinkProps,
}: OwnProps) => {
  const { t } = useContext(AppContext);

  const handleClickOut = useCallback(
    (e: React.MouseEvent) => onClickOut(e, price.id),
    [price.id, onClickOut]
  );

  return (
    <Table.AltRow>
      <Table.Column colSpan={3} expandOnMobile>
        <Table.Link
          {...tableLinkProps}
          onClick={handleClickOut}
          href={price.externalUri!}
          vertical
          alignLeft
        >
          <div>
            <S.ProductName>{price.name}</S.ProductName>
            <S.StockStatus>
              {price && price.stock && price.stock.statusText
                ? price.stock.statusText.replace(/-/g, '\u2011')
                : t(
                    'product',
                    `stock-status.${(price.stock && price.stock.status) ||
                      'unknown'}` as keyof ParamsAndReturnTypes['product']
                  )}
            </S.StockStatus>
          </div>
        </Table.Link>
      </Table.Column>
      <Table.Column>
        <Table.Link
          {...tableLinkProps}
          onClick={handleClickOut}
          href={price.externalUri!}
          alignRight
        >
          <StockStatusColumn
            status={
              price.stock && price.stock.status ? price.stock.status : undefined
            }
            statusText={
              price.stock && price.stock.statusText
                ? price.stock.statusText
                : undefined
            }
            countryCode={priceStore.countryCode}
            toneDown={!priceStore.featured}
            isInternationalPrice={isInternationalPrice}
          />
        </Table.Link>
      </Table.Column>
      <Table.Column>
        <Table.Link
          {...tableLinkProps}
          onClick={handleClickOut}
          href={price.externalUri!}
          alignRight
        >
          {price.price && (
            <PriceColumn
              price={price.price}
              storeIsFeatured={priceStore.featured}
              campaignStyling={campaignStyling}
              isInternationalPrice={isInternationalPrice}
              align="right"
            />
          )}
        </Table.Link>
      </Table.Column>
      <Table.Column>
        <Table.Link
          {...tableLinkProps}
          onClick={handleClickOut}
          href={price.externalUri!}
          alignRight
        >
          <GoToStoreButton
            visible={Boolean(externalUri || priceStore.featured)}
            disabled={Boolean(externalUri && !priceStore.featured)}
            featured={priceStore.featured}
          />
        </Table.Link>
      </Table.Column>
    </Table.AltRow>
  );
};

export default AlternativePriceRow;
